import type { Business } from "@/types";
import BusinessCard from "@/components/feature/BusinessCard";

interface BusinessGridProps {
  businesses: Business[];
  columns?: 2 | 3;
}

export default function BusinessGrid({ businesses, columns = 3 }: BusinessGridProps) {
  const cols = columns === 2 ? "lg:grid-cols-2" : "lg:grid-cols-3";
  return (
    <div className={`grid grid-cols-1 sm:grid-cols-2 ${cols} gap-4 md:gap-5`}>
      {businesses.map((b) => (
        <BusinessCard key={b.id} business={b} />
      ))}
    </div>
  );
}